import React, { useState } from "react";
import "./App.css"; 

const Subantarupaani = () => {
    const [expandedRow, setExpandedRow] = useState(null);
    const [expandedSubRows, setExpandedSubRows] = useState({}); 
    const [expandedSubSubRows, setExpandedSubSubRows] = useState({}); 
    const [expandedSubSubSubRows, setExpandedSubSubSubRows] = useState({});

    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
        setExpandedSubRows({}); 
        setExpandedSubSubRows({});
        setExpandedSubSubSubRows({}); 
    };

    const toggleSubRow = (rowIndex, subIndex) => {
        setExpandedSubRows({
            ...expandedSubRows,
            [subIndex]: expandedSubRows[subIndex] === rowIndex ? null : rowIndex
        });
        setExpandedSubSubRows({}); 
        setExpandedSubSubSubRows({});
    };

    const toggleSubSubRow = (subIndex, subSubIndex) => {
        setExpandedSubSubRows({
            ...expandedSubSubRows,
            [subSubIndex]: expandedSubSubRows[subSubIndex] === subIndex ? null : subIndex
        });
        setExpandedSubSubSubRows({});
    };

    const toggleSubSubSubRow = (subSubIndex, subSubSubIndex) => {
        setExpandedSubSubSubRows({
            ...expandedSubSubSubRows,
            [subSubSubIndex]: expandedSubSubSubRows[subSubSubIndex] === subSubIndex ? null : subSubIndex
        });
    };

    const tableData = [
        {
            id: 0,
            label: "विभक्त्यर्थाः",
            example: "सु, औ, जस् ...",
            options: [
                { text: "Link 1", link: "#option1" },
                { text: "Link 2", link: "#option2" },
                {
                    text: "Link 3",
                    link: "#option3",
                    subOptions: [
                        { text: "Link 4", link: "#option4" },
                        { text: "Link 5", link: "#option5" },
                        {
                            text: "Link 6",
                            link: "#option6",
                            subOptions: [
                                { text: "Link 7", link: "#option7" },
                                {
                                    text: "Link 8",
                                    link: "#option8",
                                    subOptions: [
                                        { text: "Link 9", link: "#option9" },
                                        { text: "Link 10", link: "#option10" },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        { id: 1, label: "अजन्त पुंलिङ्ग साधारण शब्दाः", example: "रामः, रमा, ज्ञानम् ..." },
        { id: 2, label: "अजन्त स्त्रीलिङ्ग साधारण शब्दाः", example: "रमा, मतिः, गौरी ...." },
        { id: 3, label: "अजन्त नपुंसकलिङ्ग साधारण शब्दाः", example: "ज्ञानम्, वारि, मधु ..." },
        { id: 4, label: "हलन्त पुंलिङ्ग साधारण शब्दाः", example: "जलमुक्, भिषक्, मरुत् ..." },
        { id: 5, label: "हलन्त स्त्रीलिङ्ग साधारण शब्दाः", example: "क्षुत्, ककुप् ..." },
        { id: 6, label: "हलन्त नपुंसकलिङ्ग साधारण शब्दाः", example: "सुवाक्, महत् ..." },
        { id: 7, label: "उपसर्गाः", example: "प्र, वि, परा ..." },
        { id: 8, label: "सर्वनाम शब्दाः", example: "सर्व, विश्व, अस्मत्, युष्मत् ..." },
        { id: 9, label: "अव्ययानि (चादयः, स्वरादयः)", example: "च, स्वः, अद्धा ..." },
    ];

    return (
        <table className="subantarupaani-table">
            <thead>
                <tr>
                    <th className="serial-number">क्रमसङ्ख्या</th>
                    <th className="label-column">विविध शब्दाः</th>
                    <th className="example-column">उदाहरणम्</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map((row, index) => (
                    <React.Fragment key={row.id}>
                        <tr>
                            <td className="serial-number">{row.id}</td>
                            <td className="label-column">
                                <span
                                    className={`box ${expandedRow === index ? "check-box" : ""}`}
                                    onClick={() => toggleRow(index)}
                                >
                                    {row.label}
                                </span>
                            </td>
                            <td className="example-column">{row.example}</td>
                        </tr>
                        {expandedRow === index && row.options && (
                            <tr>
                                <td className="collapse-content-td" colSpan="3">
                                    <ul className={`nested ${expandedRow === index ? "active" : ""}`}>
                                        {row.options.map((option, i) => (
                                            <React.Fragment key={i}>
                                                <li>
                                                    {option.subOptions ? (
                                                        <span
                                                            className={`box-options ${expandedSubRows[i] === index ? "check-box" : ""}`}
                                                            onClick={() => toggleSubRow(index, i)}
                                                        >
                                                            {option.text}
                                                        </span>
                                                    ) : (
                                                        <a href={option.link}>{option.text}</a>
                                                    )}
                                                    {expandedSubRows[i] === index && option.subOptions && (
                                                        <ul className="nested active">
                                                            {option.subOptions.map((subOption, j) => (
                                                                <React.Fragment key={j}>
                                                                    <li>
                                                                        {subOption.subOptions ? (
                                                                            <span
                                                                                className={`box-options ${expandedSubSubRows[j] === i ? "check-box" : ""}`}
                                                                                onClick={() => toggleSubSubRow(i, j)}
                                                                            >
                                                                                {subOption.text}
                                                                            </span>
                                                                        ) : (
                                                                            <a href={subOption.link}>{subOption.text}</a>
                                                                        )}
                                                                        {expandedSubSubRows[j] === i && subOption.subOptions && (
                                                                            <ul className="nested active">
                                                                                {subOption.subOptions.map((subSubOption, k) => (
                                                                                    <React.Fragment key={k}>
                                                                                        <li>
                                                                                            {subSubOption.subOptions ? (
                                                                                                <span
                                                                                                    className={`box-options ${expandedSubSubSubRows[k] === j ? "check-box" : ""}`}
                                                                                                    onClick={() => toggleSubSubSubRow(j, k)}
                                                                                                >
                                                                                                    {subSubOption.text}
                                                                                                </span>
                                                                                            ) : (
                                                                                                <a href={subSubOption.link}>{subSubOption.text}</a>
                                                                                            )}
                                                                                            {expandedSubSubSubRows[k] === j && subSubOption.subOptions && (
                                                                                                <ul className="nested active">
                                                                                                    {subSubOption.subOptions.map((subSubSubOption, l) => (
                                                                                                        <li key={l}>
                                                                                                            <a href={subSubSubOption.link}>{subSubSubOption.text}</a>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            )}
                                                                                        </li>
                                                                                    </React.Fragment>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                </React.Fragment>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            </React.Fragment>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
};

export default Subantarupaani;
